import React from "react";
import { CONTABILI } from "../../../data";
import { TrendingUp, ArrowUpRight } from "lucide-react";

const INSTA_LINK = "https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MjIxMTk3Njg0MzMxNDI4?story_media_id=3892375062141815165_79662515577&stkn=MW83bTh3ZXQ2MzU2NQ==";

function Card({ c }) {
  return (
    <div
      onClick={() => window.open(INSTA_LINK, "_blank", "noopener")}
      className="v-card p-5 shrink-0 mx-2.5"
      style={{ width: 320, cursor: "pointer" }}
      data-testid="contabile-card"
    >
      <div className="v-sans flex items-center gap-2 mb-4" style={{ fontSize: "0.6rem", letterSpacing: "0.14em", color: "rgba(255,255,255,0.35)", textTransform: "uppercase" }}>
        <span style={{ width: 7, height: 7, borderRadius: 999, background: "rgba(255,255,255,0.18)" }} />
        <span style={{ width: 7, height: 7, borderRadius: 999, background: "rgba(255,255,255,0.18)" }} />
        <span className="ml-1">KPI</span>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <div className="v-sans" style={{ fontSize: "0.58rem", letterSpacing: "0.12em", color: "rgba(255,255,255,0.4)", textTransform: "uppercase" }}>Fatturato</div>
          <div className="v-sans v-ink" style={{ fontSize: "1.6rem", fontWeight: 700, marginTop: 4 }}>{c.fatturato}</div>
          <div className="v-sans flex items-center gap-1" style={{ fontSize: "0.68rem", color: "#98959F", marginTop: 3 }}>
            {c.vendite} <span style={{ color: "#34D07F" }}>▲{c.dv}</span>
          </div>
        </div>
        <div>
          <div className="v-sans" style={{ fontSize: "0.58rem", letterSpacing: "0.12em", color: "rgba(224,174,85,0.7)", textTransform: "uppercase" }}>Cash Collected</div>
          <div className="v-sans v-gold" style={{ fontSize: "1.6rem", fontWeight: 700, marginTop: 4 }}>{c.cash}</div>
          <div className="v-sans flex items-center gap-1" style={{ fontSize: "0.68rem", color: "#98959F", marginTop: 3 }}>
            incasso <span style={{ color: "#34D07F" }}>▲{c.dc}</span>
          </div>
        </div>
      </div>
      <svg viewBox="0 0 300 34" className="w-full mt-4" style={{ height: 30 }} preserveAspectRatio="none">
        <polyline points="0,30 40,26 80,28 120,18 160,21 200,10 240,12 300,3" fill="none" stroke="#E0AE55" strokeWidth="2" />
      </svg>
    </div>
  );
}

export default function Contabili() {
  const loop = [...CONTABILI.cards, ...CONTABILI.cards];
  return (
    <section className="py-16 overflow-hidden" style={{ borderTop: "1px solid rgba(255,255,255,0.07)", borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
      <div className="text-center mb-10 px-4">
        <div className="v-label">{CONTABILI.label}</div>
        <div className="mt-5 flex justify-center">
          <button
            data-testid="contabili-view-all"
            onClick={() => window.open(INSTA_LINK, "_blank", "noopener")}
            className="v-btn v-btn-blue"
          >
            Guardale tutte <ArrowUpRight size={18} />
          </button>
        </div>
      </div>
      <div className="relative">
        <div className="hts-marquee-track" style={{ display: "flex", width: "max-content" }}>
          {loop.map((c, i) => (<Card key={i} c={c} />))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0" style={{ width: 90, background: "linear-gradient(90deg, #050506, transparent)" }} />
        <div className="pointer-events-none absolute inset-y-0 right-0" style={{ width: 90, background: "linear-gradient(270deg, #050506, transparent)" }} />
      </div>
    </section>
  );
}
